import { DEPLOY_ENV } from '#client/public-env';

/**
 * Generate a Fully Qualified URL
 *
 * @param {string} route
 * @returns {string} url
 */
export const generateZenUrl = (route) => {
  if (!route) {
    return null;
  }
  if (DEPLOY_ENV === 'webpack' || DEPLOY_ENV === 'local') {
    return `http://local.zenbusiness.com:8080/${route.replace(/^\/+/, '')}`;
  }
  return `https://www${DEPLOY_ENV === 'production' ? '.' : '.dev.'}zenbusiness.com/${route.replace(/^\/+/, '')}`;
};

/**
 * Generate a redirect path to shopping-ui
 * using the lead details to restore the flow state (if available)
 *
 * @param {object} leadDetails - Lead details object
 * @param {string} [leadDetails.flowName] - The flow name to redirect to
 * @param {string} [leadDetails.uuid] - The UUID to restore flow state
 * @returns {string} redirect URL - Falls back to '/shop/' if no lead details provided
 */
export const generateShoppingUiRedirectUrl = (leadDetails = {}) => {
  const { flowName, uuid } = leadDetails;
  const flowPath = flowName || '';
  const flowStateIdentifier = uuid && typeof uuid === 'string' ? `?restoreState=${uuid}` : '';
  return generateZenUrl(`/shop/${flowPath}${flowStateIdentifier}`);
};
